(function userControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserFindController', [
            '$scope', 'config', '$state', '$translate', '$filter', 'errorsExtend', 'adminUserService', 'authExtend', 'fileDownloader', 'storageService', 'messages',
            function userController($scope, config, $state, $translate, $filter, errors, adminUserService, authExtend, fileDownloader, storageService, messages) {

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (user) {
                            user.check = $scope.checkAll;
                        });
                    }
                };

                $scope.actionFind = function () {
                    storageService.setUsersFilter($scope.find);
                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.find.showResult = false;

                    return adminUserService.get(
                        $scope.find.NickName,
                        $scope.find.FirstName,
                        $scope.find.LastName,
                        $scope.find.userEnabled,
                        $scope.find.userLocked,
                        $scope.find.organizationalUnitId,
                        null, null,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                        ).then(function getOk(result) {
                            $scope.items = result.value;
                            $scope.data.totalItems = result.totalCount;
                            $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));

                            if ($scope.items.length === 0) {
                                $scope.find.showNoData = true;
                            } else {
                                $scope.find.showResult = true;
                            }

                        }, function getError(error) {
                            errors.showError(error);
                        });
                };

                $scope.exportToExcel = function () {
                    return $translate(['UserNickName', 'UserFirstName', 'UserLastName', 'UserMail', 'UserOrganizationalUnit', 'UserEnabled', 'UserLocked'])
                        .then(function (translated) {
                            var headers = [];

                            headers.push({ key: 'NickName', value: translated.UserNickName });
                            headers.push({ key: 'FirstName', value: translated.UserFirstName });
                            headers.push({ key: 'LastName', value: translated.UserLastName });
                            headers.push({ key: 'Mail', value: translated.UserMail });
                            headers.push({ key: 'OrganizationalUnitName', value: translated.UserOrganizationalUnit });
                            headers.push({ key: 'Enabled', value: translated.UserEnabled });
                            headers.push({ key: 'Locked', value: translated.UserLocked });

                            return adminUserService.exportToXLS({
                                nickName: $scope.find.NickName,
                                firstName: $scope.find.FirstName,
                                lastName: $scope.find.LastName,
                                organizationalUnitId: $scope.find.organizationalUnitId,
                                enabled: $scope.find.userEnabled,
                                locked: $scope.find.userLocked
                            }, headers, "Usuarios").then(function (result) {
                                var d = new Date();
                                var docName = "Usuarios";
                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 403) {
                                    errors.showError('FileForbidden');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                };

                $scope.modify = function (userOU) {
                    $state.go('user-modify', { id: userOU.id });
                };

                $scope.view = function (userOU) {
                    $state.go('user-detail', { id: userOU.id });
                };

                $scope.add = function () {
                    $state.go('user-add');
                };

                $scope.unLock = function (user) {
                    return adminUserService.unlock(user).then(function getOk() {
                        errors.showSuccess('UserUnlockSucces');
                        $scope.actionFind();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.resetPassword = function (user) {

                    return adminUserService.reset(user).then(function getOk(result) {
                        errors.showSuccess('UserResetSucces');
                        $scope.actionFind();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.resetPasswords = function () {
                    var users = {
                        Ids: []
                    };

                    $scope.items.forEach(function (item) {
                        if (item.check) {
                            users.Ids.push(item.id);
                        }
                    });

                    if (users.Ids.length == 0) {
                        errors.showWarning('UserSelectItemWarning');
                        return false;
                    }

                    messages.showConfirm('UserResetAllPassWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: users.Ids.length })
                        .then(function (confirm) {
                            if (confirm) {
                                $scope.loading = true;
                                return adminUserService.resetBatch(users).then(function (result) {
                                    $scope.loading = false;
                                    errors.showSuccess('UserResetBatchResult', 'InfoTitle', { count: result });
                                }, function (error) {
                                    $scope.loading = false;
                                    errors.showError(error);
                                });
                            }
                        });
                };

                $scope.resetAllPasswords = function () {
                    messages.showConfirm('UserResetAllPassWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: $scope.data.totalItems })
                        .then(function (confirm) {
                            if (confirm) {
                                $scope.loading = true;

                                return adminUserService.get($scope.find.NickName, $scope.find.FirstName, $scope.find.LastName,
                                    $scope.find.organizationalUnitId, null, null, $scope.data.currentPage, null).then(function getOk(result) {
                                        var users = {
                                            Ids: []
                                        };

                                        result.value.forEach(function (item) {
                                            users.Ids.push(item.id);
                                        });

                                        return adminUserService.resetBatch(users).then(function (result) {
                                            $scope.loading = false;
                                            errors.showSuccess('UserResetBatchResult', 'InfoTitle', { count: result });
                                        }, function (error) {
                                            $scope.loading = false;
                                            errors.showError(error);
                                        });
                                    }, function getError(error) {
                                        errors.showError(error);
                                    });
                            }
                        });
                };

                $scope.roles = function (user) {
                    $state.go('user-roles', { id: user.id });
                };

                $scope.enable = function (userOU) {
                    return $scope.enable_disable(userOU, true);
                }

                $scope.disable = function (userOU) {
                    return $scope.enable_disable(userOU, false);
                }

                $scope.enable_disable = function (userOU, enabled) {
                    return adminUserService.getById(userOU.id).then(function (result) {
                        var userOu = result;
                        userOu.enabled = enabled;

                        return adminUserService.modify(userOu).then(function () {
                            userOU.enabled = enabled;
                            $state.go('user-find');
                        }, function (error) {
                            errors.showError(error);
                        });
                    });
                }

                $scope.load = function () {
                    $scope.find = storageService.getUsersFilter();
                    $scope.find.showNoData = false;
                    $scope.find.showResult = false;
                    $scope.hideAddBtn = !authExtend.isInRole('USER WRITE');
                    $scope.hideAddRolesBtn = !authExtend.isInRole('ROLE ASSIGN');
                    $scope.items = [];
                    $scope.checkAll = false;
                    $scope.emptyOu = true;
                    $scope.loading = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };

                            $scope.actionFind();
                        });
                }

                $scope.export = function () {
                    var ids = [];

                    $scope.items.forEach(function (user) {
                        ids.push(user.id);
                    });

                    adminUserService.export($scope.find.NickName, $scope.find.FirstName,
                        $scope.find.LastName,
                        $scope.find.userEnabled,
                        $scope.find.userLocked,
                        $scope.find.organizationalUnitId,
                        null, null,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage,
                        null,
                        config.appId()).then(function getOk(result) {
                            var d = new Date();
                            var month = d.getUTCMonth() + 1;

                            var success = fileDownloader.saveAs(result.value, 'Listado de Usarios - Roles ' +
                                d.getUTCFullYear() +
                                ("00".substring(0, 2 - (month + '').length) + month) +
                                ("00".substring(0, 2 - (d.getDate() + '').length) + d.getDate()) +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }
                        }, function getError(error) {
                            errors.showError(error);
                        });
                };

                $scope.load();
            }
        ]);
})();